import { useEffect, useState } from 'react';

// Inline-editable cell. Click-to-edit; Enter/blur saves; Esc cancels.
export const EditableCell = ({
  value,
  type = 'text',
  options = null,
  suggestions = null,
  displayValue = null,
  onSave,
  testId,
  className = '',
}) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? '');

  useEffect(() => { setDraft(value ?? ''); }, [value]);

  const commit = () => {
    setEditing(false);
    const norm = type === 'number' ? (draft === '' ? 0 : Number(draft)) : draft;
    if (String(norm) !== String(value ?? '')) onSave(norm);
  };

  const cancel = () => { setDraft(value ?? ''); setEditing(false); };

  if (!editing) {
    return (
      <span
        data-testid={testId}
        onClick={() => setEditing(true)}
        title="Click to edit"
        className={`block min-w-[60px] px-1 py-0.5 -mx-1 rounded cursor-cell hover:bg-[#143E29] hover:outline hover:outline-1 hover:outline-[#A3E635] transition-colors ${className}`}
      >
        {displayValue ?? (value || <span className="text-[#666] italic">—</span>)}
      </span>
    );
  }

  if (options) {
    return (
      <select
        data-testid={`${testId}-input`}
        autoFocus
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') cancel(); }}
        className="bg-white border-2 border-[#A3E635] rounded px-1 py-0.5 text-black font-bold text-sm cursor-pointer"
      >
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  }

  return (
    <>
      <input
        data-testid={`${testId}-input`}
        autoFocus
        type={type}
        list={suggestions ? `${testId}-suggestions` : undefined}
        autoComplete="off"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') cancel(); }}
        className="bg-white border-2 border-[#A3E635] rounded px-1 py-0.5 text-black text-sm w-full min-w-[80px]"
      />
      {suggestions && <datalist id={`${testId}-suggestions`}>{suggestions.map(s => <option key={s} value={s} />)}</datalist>}
    </>
  );
};
